module.exports = __webpack_public_path__ + "static/media/Wipro.aec50d21.png";